<section class="message">
  <i class="fa" [ngClass]="icon" alt="icon"></i>
  <span class="title"><ng-content></ng-content></span>
  <!--<span *ngIf="text">{{ text }}</span>-->
</section>
